import { Component } from '@theme/component';

// No network requests and no checkout interception. The existing cart POST
// submits the selected values. Accelerated checkout remains unchanged.
let currentChoice = null;

class WmInvoiceChoice extends Component {
  #controller;

  connectedCallback() {
    super.connectedCallback();
    this.#controller?.abort();
    this.#controller = new AbortController();
    this.addEventListener('change', this.#change, { signal: this.#controller.signal });
    if (currentChoice) this.#apply(currentChoice);
  }

  disconnectedCallback() {
    this.#controller?.abort();
    super.disconnectedCallback();
  }

  #change = (event) => {
    if (!(event.target instanceof HTMLSelectElement) || !event.target.matches('[data-wm-format]')) return;
    const format = event.target.value;
    if (!['', 'pdf_email', 'paper'].includes(format)) return;
    currentChoice = format
      ? { format, version: '2026-11-04-v1', at: new Date().toISOString(), source: 'cart_select' }
      : { format: '', version: '', at: '', source: '' };
    document.querySelectorAll('wm-invoice-choice').forEach((component) => {
      if (component instanceof WmInvoiceChoice) component.#apply(currentChoice);
    });
  };

  #apply(choice) {
    const fields = { format: 'format', version: 'version', at: 'at', source: 'source' };
    for (const [name, property] of Object.entries(fields)) {
      const field = this.querySelector(`[data-wm-${name}]`);
      if (field instanceof HTMLSelectElement || field instanceof HTMLInputElement) {
        field.value = choice[property];
      }
    }
  }
}

if (!customElements.get('wm-invoice-choice')) {
  customElements.define('wm-invoice-choice', WmInvoiceChoice);
}
